import axios from '@/axios';

export async function getProfiles(params) {
    const { data } = await axios.get("/profiles/filter", { params });
    return data;
}

export async function saveProfile(id, data) {
    const method = id ? 'PUT' : 'POST';
    const url = id ? `/profiles/${id}` : `/profiles`;
    return await axios({ method, url, data: data });
}

export async function getAbilities() {
    const { data } = await axios.get("/abilities");
    return data.data ? data.data : data;
}

export async function saveAbilities(profileId, data ) {
    return await axios.post(`/profiles/${profileId}/abilities`, data);
}
